"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Handler = /** @class */ (function () {
    function Handler(cookieConfig, env) {
        this._cookieConfig = cookieConfig;
        this._isdebug = !env.toUpperCase().includes('PRO');
    }
    // Read user selection
    Handler.prototype.apply_consent = function () {
        var cmapi_cookie_privacy = [];
        if (typeof (truste) !== 'undefined') {
            // 2. if consent decision is
            var consentDecision = truste.cma.callApi('getConsentDecision', document.domain);
            if (consentDecision.source == 'asserted') {
                var temp = this.getCookie('cmapi_cookie_privacy');
                if (temp != null) {
                    var pattern_1 = /[0-9]/g;
                    temp = temp.replace('permit ', '');
                    var arr = temp.split(',');
                    arr.forEach(function (element) {
                        var value = element.match(pattern_1);
                        if (value == null) {
                            cmapi_cookie_privacy.push(0);
                        }
                        else {
                            cmapi_cookie_privacy.push(parseInt(value.toString()));
                        }
                    });
                }
                try {
                    this.disable_cookies(cmapi_cookie_privacy);
                }
                catch (error) {
                    console.log('ERROR >>> ' + error);
                }
            }
            else if (this._cookieConfig.behavior == "implied") {
                this.disable_cookies(cmapi_cookie_privacy);
            }
        }
    };
    Handler.prototype.loadDynatraceScript = function () {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.src = 'https://ofh289.dynatrace-managed.com/e/7c0c1551-8cc2-4dfa-ad3e-d14699330e07/api/v1/rum/jsTag/APPLICATION-3EC5F1784D2EB968/ruxitagentjs_ICA2SVfhjqrux_10223210811140219.js';
        script.setAttribute('async', 'async');
        script.setAttribute('crossorigin', '');
        head.appendChild(script);
    };
    Handler.prototype.disable_cookies = function (cmapi_cookie_privacy) {
        var _this = this;
        this._cookieConfig.cookies.forEach(function (cookie_auth) {
            var i = 0;
            var element = cmapi_cookie_privacy[i];
            var consent = cookie_auth.type == element;
            while (cmapi_cookie_privacy.length > 0 && !consent && i < cmapi_cookie_privacy.length) {
                if (cookie_auth.type == element) {
                    consent = true;
                }
                element = cmapi_cookie_privacy[i];
                i++;
            }
            switch (cookie_auth.name) {
                case 'dt':
                    _this.enable_dynatrace(consent);
                    break;
                case 'ga':
                    _this.enable_googleAnalytics(consent, cookie_auth);
                    break;
                case 'fb':
                    _this.enable_facebook(consent);
                    break;
                case 'gmaps':
                    _this.enable_gmaps(consent);
                    break;
                case 'google':
                    _this.enable_google(consent);
                    break;
                case 'dojo':
                    _this.enable_dojo(consent);
                    break;
                case 'phpword':
                    _this.enable_dojo(consent);
                    break;
            }
        });
    };
    Handler.prototype.enable_dynatrace = function (enable) {
        if (typeof (dtrum) === 'undefined' && !this._isdebug) {
            this.loadDynatraceScript();
        }
        if (enable && !this._isdebug) {
            dtrum.enable();
        }
        else if (!enable) {
            // Session storage cookies
            this.deleteCookie('dtCookie');
            this.deleteCookie('rxvisitid');
            this.deleteCookie('rxvt');
            this.deleteCookie('dtSa');
            this.deleteCookie('rxVisitor');
            this.deleteCookie('dtPC');
            this.deleteCookie('dtLatC');
            if (!this._isdebug) {
                dtrum.disable();
            }
        }
    };
    Handler.prototype.enable_google = function (enable) {
        if (enable && !this._isdebug) {
            return;
        }
        this.deleteCookie('OGPC');
        this.deleteCookie('OGP');
        this.deleteCookie('NID');
        this.deleteCookie('1P_JAR');
        this.deleteCookie('DV');
        this.deleteCookie('CGIC');
        this.deleteCookie('pm_sess');
        this.deleteCookie('YSC');
    };
    Handler.prototype.enable_gmaps = function (enable) {
        if (enable && !this._isdebug) {
            return;
        }
        this.deleteCookie('gsScrollPos');
        this.deleteCookie('1P_JAR');
        this.deleteCookie('CONSENT');
    };
    Handler.prototype.enable_dojo = function (enable) {
        if (enable && !this._isdebug) {
            return;
        }
        if (typeof (dojo) !== 'undefined') {
            dojo.cookie("configObj", null, { expires: -1 });
        }
    };
    Handler.prototype.enable_phpword = function (enable) {
        if (enable && !this._isdebug) {
            return;
        }
        this.deleteCookie('fcPlcfcookie');
        this.deleteCookie('fcCookieData');
        this.deleteCookie('lcbCookieData');
        this.deleteCookie('lcbPlcfcookie');
        this.deleteCookie('fcPlcfCookieOld');
        this.deleteCookie('lcbPlcfCookieOld');
    };
    Handler.prototype.enable_googleAnalytics = function (enable, config) {
        if (enable && !this._isdebug) {
            return;
        }
        /* Please check tracking Id from.json file
        Taken from \w959686\vnewpage.php and \w261818\vnewpage.php */
        if (typeof config.trackingId !== undefined && typeof config.trackingId === 'string') {
            window['ga-disable-' + config.trackingId] = true;
        }
        this.deleteCookie('_ga');
        this.deleteCookie('NID');
        this.deleteCookie('SID');
        this.deleteCookie('_gid');
        this.deleteCookie('SSID');
        this.deleteCookie('HSID');
        this.deleteCookie('SAPISID');
        this.deleteCookie('__utma');
        this.deleteCookie('__utmb');
        this.deleteCookie('__utmc');
        this.deleteCookie('__utmt');
        this.deleteCookie('__utmz');
    };
    Handler.prototype.enable_facebook = function (enable) {
        if (enable && !this._isdebug) {
            return;
        }
        this.deleteCookie('sb');
        this.deleteCookie('fr');
        this.deleteCookie('wd');
        this.deleteCookie('xs');
        this.deleteCookie('sb');
        this.deleteCookie('oo');
        this.deleteCookie('dpr');
        this.deleteCookie('act');
        this.deleteCookie('datr');
        this.deleteCookie('spin');
        this.deleteCookie('_fbp');
        this.deleteCookie('dbln');
        this.deleteCookie('c_user');
        this.deleteCookie('presence');
        this.deleteCookie('reg_fb_ref');
        this.deleteCookie('reg_fb_gate');
        this.deleteCookie('reg_ext_ref');
        this.deleteCookie('_js_reg_fb_ref');
    };
    /*
    * General utils for managing cookies in Typescript.
    */
    Handler.prototype.setCookie = function (name, val) {
        var date = new Date();
        var value = val;
        // Set it expire in 7 days
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
        // Set it
        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    };
    Handler.prototype.getCookie = function (name) {
        var nameLenPlus = (name.length + 1);
        return document.cookie
            .split(';')
            .map(function (c) { return c.trim(); })
            .filter(function (cookie) {
            return cookie.substring(0, nameLenPlus) === name + "=";
        })
            .map(function (cookie) {
            return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    };
    Handler.prototype.deleteCookie = function (name) {
        var date = new Date();
        sessionStorage.removeItem(name);
        // Set it expire in -1 days
        date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
        // Set it
        document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
    };
    return Handler;
}());
exports.Handler = Handler;
